"use client";
import { getBreakpointValue } from "../get-breakpoint-value/get-breakpoint-value.mjs";
//#region packages/@mantine/core/src/core/utils/get-sorted-breakpoints/get-sorted-breakpoints.ts
function getSortedBreakpoints(values, breakpoints) {
	const convertedBreakpoints = values.map((breakpoint) => ({
		value: breakpoint,
		px: getBreakpointValue(breakpoint, breakpoints)
	}));
	convertedBreakpoints.sort((a, b) => a.px - b.px);
	return convertedBreakpoints;
}
//#endregion
export { getSortedBreakpoints };

//# sourceMappingURL=get-sorted-breakpoints.mjs.map